<template>
  <form class="form" @submit.prevent="onSubmit()">
    <FormGroup :v="v$.enable_email" label="">
      <ToggleField
        id="enable_email"
        :model-value="formValue.enable_email"
        @update:model-value="(val) => onChangeEmail(val)"
      >
        {{ $t("profile.notifications.reservationReminderEmail") }}
      </ToggleField>
    </FormGroup>
    <FormGroup :v="v$.enable_sms" label="">
      <ToggleField
        id="enable_sms"
        :model-value="formValue.enable_sms"
        @update:model-value="(val) => onChangeEnableSms(val)"
      >
        {{ $t("profile.notifications.reservationReminderSms") }}
      </ToggleField>
    </FormGroup>
    <FormGroup v-if="isPhoneRequired" :v="v$.phone" label="label.phone">
      <TextField
        v-model="formValue.phone"
        type="text"
        inputmode="phone"
        :disabled="props.disabled"
        placeholder="placeholder.phone"
        autocomplete="phone"
      />
    </FormGroup>
    <slot></slot>
  </form>
</template>

<script setup lang="ts">
import { computed, reactive } from "vue";
import FormGroup from "@/components/form/form-group.vue";
import TextField from "@/components/form/text-field.vue";
import { phone } from "@/utils/validators";
import useVuelidate from "@vuelidate/core";
import { ReservationNotificationData } from "@/types";
import { required } from "@vuelidate/validators";

import ToggleField from "@/components/form/toggle-field.vue";

const props = defineProps<{
  disabled?: boolean;
  value?: ReservationNotificationData | null;
}>();

const emit = defineEmits<{
  (e: "submit", v: ReservationNotificationData): void;
}>();

const formValue = reactive<ReservationNotificationData>({
  enable_email: !!props.value?.enable_email,
  enable_sms: !!props.value?.enable_sms,
  phone: props.value?.phone ?? "",
});

const isPhoneRequired = computed(
  () => !props.value?.enable_sms && !props.value?.phone && formValue.enable_sms
);

const rules = computed(() =>
  isPhoneRequired.value ? { phone: { phone, required } } : {}
);

const v$ = useVuelidate(rules, formValue);

const onSubmit = () => {
  v$.value.$touch();

  if (!v$.value.$invalid) {
    emit("submit", { ...formValue });
  }
};

const onChangeEmail = (value: boolean) => {
  formValue.enable_email = value;
};
const onChangeEnableSms = (value: boolean) => {
  formValue.enable_sms = value;
};
</script>
